import { Link } from "react-router-dom";
import { categories, rankings, latestUpdates } from "@/mocks/comics";

export default function QuickNavSection() {
  return (
    <section className="py-16 md:py-20 px-6 md:px-10 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 md:gap-10">
          <div>
            <h3 className="text-lg font-semibold text-foreground-950 mb-5 flex items-center gap-2">
              <i className="ri-price-tag-3-line text-accent-500"></i>
              热门分类
            </h3>
            <div className="grid grid-cols-2 gap-2">
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="flex items-center gap-2.5 px-3 py-2.5 rounded-xl hover:bg-background-100 transition-colors group"
                >
                  <span className={`w-8 h-8 rounded-lg flex items-center justify-center ${cat.color} text-sm`}>
                    <i className={cat.icon}></i>
                  </span>
                  <div>
                    <p className="text-sm font-medium text-foreground-800 group-hover:text-foreground-950 transition-colors">{cat.name}</p>
                    <p className="text-xs text-foreground-400">{cat.count}部</p>
                  </div>
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h3 className="text-lg font-semibold text-foreground-950 mb-5 flex items-center gap-2">
              <i className="ri-fire-line text-accent-500"></i>
              人气排行
            </h3>
            <div className="space-y-1">
              {rankings.slice(0, 8).map((item) => (
                <Link
                  key={item.rank}
                  to={`/comic/${item.rank}`}
                  className="flex items-center gap-3 px-3 py-2 rounded-xl hover:bg-background-100 transition-colors"
                >
                  <span className={`text-sm font-bold w-6 text-center ${item.rank <= 3 ? 'text-accent-500' : 'text-foreground-400'}`}>
                    {item.rank.toString().padStart(2, '0')}
                  </span>
                  <span className="text-sm text-foreground-800 flex-1 truncate">{item.title}</span>
                  <span className="text-xs text-foreground-400 flex items-center gap-1">
                    {item.trend === 'up' ? <i className="ri-arrow-up-line text-emerald-500"></i> : <i className="ri-arrow-down-line text-red-400"></i>}
                    {item.views}
                  </span>
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h3 className="text-lg font-semibold text-foreground-950 mb-5 flex items-center gap-2">
              <i className="ri-timer-line text-accent-500"></i>
              最新更新
            </h3>
            <div className="space-y-4">
              {latestUpdates.map((comic) => (
                <Link
                  key={comic.id}
                  to={`/comic/${comic.id}`}
                  className="flex gap-4 group"
                >
                  <div className="w-16 h-20 rounded-lg overflow-hidden flex-shrink-0 bg-background-200">
                    <img src={comic.coverImage} alt={comic.title} className="w-full h-full object-cover object-top" />
                  </div>
                  <div className="flex-1 min-w-0">
                    <p className="text-sm font-medium text-foreground-800 group-hover:text-foreground-950 transition-colors truncate">{comic.title}</p>
                    <p className="text-xs text-foreground-400 mt-0.5">{comic.author}</p>
                    <p className="text-xs text-accent-500 mt-1">{comic.latestChapter}</p>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}